module.exports = __webpack_public_path__ + "img/one_11.83fa4315.png";